// extracted by mini-css-extract-plugin
export default {"custom-select":"SelectSerial_custom-select__dlW8U","header-select":"SelectSerial_header-select__jo6P0"};